import { AlertModalType } from "shared/components/alertModal/type";
import BaseReducer from "shared/types/baseReducer";
import { Action, ActionType, ReducerDispatch, State } from "./types.d";

export default class Reducer extends BaseReducer<ActionType> implements ReducerDispatch {
  static reducer(state: State, action: ActionType): State {
    switch (action.type) {
      case Action.SET_ALERT_CONFIG:
        return {
          ...state,
          alertConfig: action.data
        };
      case Action.OPEN_ASSIGN_TICKET_MODAL:
        return {
          ...state,
          openAssignTicket: action.data
        };
      case Action.OPEN_BUY_MORE_TICKET_MODAL:
        return {
          ...state,
          openBuyMoreTicket: action.data
        };
    }
  }
  public setAlertConfig(data?: AlertModalType) {
    return this.dispatch({ type: Action.SET_ALERT_CONFIG, data });
  }

  public setAssignTicketModal(data: boolean) {
    return this.dispatch({ type: Action.OPEN_ASSIGN_TICKET_MODAL, data });
  }

  public setBuyMoreTicket(data: boolean) {
    return this.dispatch({ type: Action.OPEN_BUY_MORE_TICKET_MODAL, data });
  }
}
